import {request, serviceUrl} from "@/utils/request";

//根据父类codes集合获取系统参数
export function getSystematicByParentCodes(codes) {
  return request({
    url: serviceUrl.extensionService + '/ext/systematic/getByParentCodes',
    params: {codes: codes}
  })
}

//获取系统讯息
export function getSystematicByParent() {
  return request({
    url: serviceUrl.iamService + '/oauth-client-details/list'
  })
}

//根据编码列表获取配置列表
export function getSystematicByCodes(codes) {
  return request({
    url: serviceUrl.extensionService + '/ext/systematic/getByCodes',
    params: {codes: codes}
  })
}

//测试系统地址是否能启动
export function getCheckUrl(item) {
    return request({
      method: 'POST',
      url: serviceUrl.iamService + '/oauth-client-details/checkUrl',
      data: {
        clientId: item.clientId,
        website: item.website,
        appName: item.appName,
        autoApprove: item.autoApprove,
        appNameEn: item.appNameEn
      }
    })
}

//保存并查询
export function preservationAndQuerySystematic(parentId, code, name, val1, val2, icon1, icon2) {
    return request({
        method: 'POST',
        url: serviceUrl.extensionService + "/ext/systematic/preservationAndQuery",
        data: {
            parentId: parentId,
            code: code,
            name: name,
            val1: val1,
            val2: val2,
            ordinal: "",
            isDisplay: true,
            icon1: icon1,
            icon2: icon2,
            note: "",
            spare: "",
            manageable: true
        },
    })
}

//保存子系统参数
export function saveOrUpdateApplication(extSystematicList) {
    return request({
        method: 'POST',
        url: serviceUrl.iamService + "/oauth-client-details/update",
        data: extSystematicList,
    });
}
//保存系统参数
export function saveOrUpdateSystematic(extSystematicList) {
  return request({
    method: 'POST',
    url: serviceUrl.extensionService + "/ext/systematic",
    data: extSystematicList,
  });
}

// 备份数据库
export function backUpDatabase() {
  return request({
    method: 'get',
    url: serviceUrl.extensionService + "/ext/systematic/backUpDatabase"
  });
}

// 还原数据库
export function restoringDatabase(url) {
  return request({
    method: 'get',
    url: serviceUrl.extensionService + "/ext/systematic/restoringDatabase",
    params: {url}
  });
}
